module.exports = __webpack_public_path__ + "static/002-slideshow-0bc03f67ab7d70bdec586c59f5b28080.jpg";